export default __webpack_public_path__ + "/assets/map-pin-orange.c4626c4e48d96e594e532a5194ab234d.png";